<template>
    <div class="navbar-header" :style="{backgroundColor: color}">
        <!-- <div class="jumpButton" v-if="allowJump()">
            <a
                vs-type="flat"
                @click="handleJump()"
            >
                Revisão
            </a>
            <feather-icon
                icon="ChevronRightIcon"
                svgClasses="stroke-current w-36.96 h-36.96"
            />
        </div> -->
        <p>{{ stepTitle }}</p>
        <div class="flex">
            <div
                v-for="(step, index) in steps"
                :key="`step-${index}`"
                class="border border-solid rounded-full w-3 h-3 mx-1 my-1"
                :class="step.order == currentStep ? 'bg-white' : ''"
            >
            </div>
        </div>
    </div>
</template>

<script>
import { mapState } from 'vuex'

export default {
    name: 'mobile-navbar',
    computed: {
        ...mapState('step', ['steps', 'currentStep']), 
        ...mapState('company', ['company']),

        stepTitle() {
            return this.steps.filter(item => item.order == this.currentStep)[0].title
        },

        color() {
            return this.company.base_hexcolor || '#1551b1'
        },
    },
    methods: {
        handleJump() {
            const resumeStep = this.$store.getters['step/getResumeStep'];

            this.$store.dispatch('step/updateCurrentStep', {
                order: resumeStep.order
            });

            this.$router.push({
                name: resumeStep.path
            })  
        },
        allowJump() {
            return !this.onEditMode() &&
                this.$store.getters['step/allowJump'] &&
                this.$store.getters['step/current'].path !== 'step-revision'
        },
        onEditMode () {
            const currentPath = this.$router.history.current.name;
            return (currentPath.slice(0, 4) == 'edit')
        },
    },
    created: async function() {
        if (this.onEditMode()) {
            const steps = {
                'edit-basic-info': 1,
                'edit-curriculumn': 2,
                'edit-address': 3,
                'edit-formation': 4,
                'edit-experiences': 5,
                'edit-languages': 6,
                'edit-skills': 7,
            }

            await this.$store.dispatch(
                'step/updateCurrentStep',
                { order: steps[this.$router.history.current.name] }
            )
        }
    }
}
</script>

<style lang="scss" scoped>
    .navbar-header {
        display: flex;
        align-items: center;
        flex-direction: column;

        -webkit-box-sizing: border-box;
        -moz-box-sizing: border-box;
        box-sizing: border-box;

        padding: 1rem;
        color: white;
    }
    .p-1-5 {
        padding: 0.40rem;
    }
    .circle.small {
        border: 2px solid #fff;
        border-radius: 50%;
        width: 1rem;
        height: 1rem;
    }
    .jumpButton {
        display: flex;
        justify-content: flex-end;
        align-items: center;
        align-self: flex-end;

        a {
            color: white;
            font-weight: 400;
            align-self: flex-end;
        }

    }
</style>